const SDK_VERSION = '7.43.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
